// import {PWMAT_RESOURCE} from './consts'

export const LongxunRoom = [
{
  name:'龙讯讲坛第一期',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k/?spm_id_from=333.999.0.0',
  file_name:'大体系计算方法Charge Patching Method原理以及应用介绍'
},
{
  name:'龙讯讲坛第二期',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=2',
  file_name:'半导体中点缺陷发光量子效率和寿命的第一性原理计算'
},
{
  name:'龙讯讲坛第三期',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=3',
  file_name:'计算大牛和我们聊一聊太阳能电池'
},
{
  name:'龙讯讲坛第四期',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=4',
  file_name:'材料计算领域新热点：非绝热分子动力学'
},
{
  name:'龙讯讲坛第五期',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=5',
  file_name:'2019新型冠状病毒介绍与抗病毒药物设计'
},
{
  name:'龙讯讲坛第六期',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=6',
  file_name:'电子束辐照下材料离化损伤模拟'
},
{
  name:'龙讯讲坛第七期',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=7',
  file_name:'半导体中的离子轰击及激光束照射等非平衡动力学效应'
},
{
  name:'龙讯讲坛第八期',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=8',
  file_name:'低维非金属催化剂的计算设计'
},
{
  name:'龙讯讲坛第九期',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=9',
  file_name:'维度无关的半导体缺陷计算理论'
},
{
  name:'龙讯讲坛第十期',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=10',
  file_name:'催化老司机带你玩转合成氨'
},
{
  name:'龙讯讲坛第十一期',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=11',
  file_name:'非线性光学晶体材料的计算与高通量筛选'
},
{
  name:'龙讯讲坛第十二期',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=12',
  file_name:'新型光伏材料及表界面态'
},
{
  name:'龙讯讲坛第十三期',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=13',
  file_name:'HPC+AI+物理模型：智能超算应用的新发展'
},
{
  name:'龙讯讲坛第十四期',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=14',
  file_name:'第一性原理模拟在锂电池研究中的应用'
},
{
  name:'龙讯讲坛第十六期',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=15',
  file_name:'非对称低维材料的二阶非线性光学性质和激子响应'
},
{
  name:'龙讯讲坛第十七期',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=16',
  file_name:'二维、三维莫尔超晶格电子性质DFT模拟'
},
{
  name:'龙讯讲坛第十八期',
  url:'https://www.bilibili.com/video/BV1dU4y1y73k?p=17',
  file_name:'固定电势法在电化学反应模拟中的应用'
},
]
